import React, { useEffect, useRef } from 'react';
import PlayIcon from '/public/svg/play.svg';
import CloseIcon from '/public/svg/close.svg';
import styles from '@/components/MultiLivestream/Schedule/ListingModal.module.scss';
interface MultiLivestreamListingModalProps {
  openModal: boolean;
  closeModal: () => void;
  channelCid: string;
  channelLogo: string;
  channelTitle: string;
  channelIsSelected: boolean;
  setUserSelectedChannel: (channelCid: string) => void;
  showTitle: string;
  episodeTitle: string;
  episodeDescription: string;
  isAiringNow: boolean;
  timeRemaining: string;
  listingProgress: number;
  listingDuration: number;
  formattedDuration: string;
}
const MultiLivestreamListingModal = (props: MultiLivestreamListingModalProps) => {
  const {
    openModal,
    closeModal,
    channelCid,
    channelLogo,
    channelTitle,
    channelIsSelected,
    setUserSelectedChannel,
    showTitle,
    episodeTitle,
    episodeDescription,
    isAiringNow,
    timeRemaining,
    listingProgress,
    listingDuration,
    formattedDuration
  } = props;
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (openModal) {
      ref.current?.showModal();
    } else {
      ref.current?.close();
    }
  }, [openModal]);
  const handleModalClick = (e: React.MouseEvent<HTMLDialogElement>) => {
    const target = e.target as HTMLElement;
    if (target === ref.current) {
      closeModal();
    }
  };
  return <dialog ref={ref} onCancel={closeModal} onClick={handleModalClick} className={styles.listing_modal} data-sentry-component="MultiLivestreamListingModal" data-sentry-source-file="ListingModal.tsx">
      {/* this inner div is necessary so we can listen for mouse clicks outside the dialog and close it in with the click event listener */}
      <div className={styles.listing_modal__inner}>
        {channelLogo ? <img src={channelLogo} className={styles.listing_modal__logo} alt={channelTitle} /> : <span className={styles.listing_modal__channel_text}>{channelTitle}</span>}
        <h2 className={styles.listing_modal__show_title}>{showTitle}</h2>
        {episodeTitle && <h3 className={styles.listing_modal__episode_title}>{episodeTitle}</h3>}
        {episodeDescription && <p className={styles.listing_modal__episode_description}>
            {episodeDescription}
          </p>}
        {isAiringNow && <>
            <div className={styles.listing_modal__progress}>
              <progress className={styles.listing_modal__progress_bar} max={listingDuration} value={listingProgress} />
              <span className={styles.listing_modal__time_remaining}>
                {timeRemaining}
              </span>
            </div>
            {!channelIsSelected && <button className={styles.listing_modal__watch_btn} onClick={() => {
          setUserSelectedChannel(channelCid);
          closeModal();
        }}>
                <PlayIcon className={styles.listing_modal__watch_btn__play_icon} />
                <span>Watch Now</span>
              </button>}
          </>}
        {!isAiringNow && <p className={styles.listing_modal__duration}>{formattedDuration}</p>}
        <button onClick={closeModal} className={styles.listing_modal__close_btn}>
          <CloseIcon className="" data-sentry-element="CloseIcon" data-sentry-source-file="ListingModal.tsx" />
          <span className="visuallyhidden">Close</span>
        </button>
      </div>
    </dialog>;
};
export default MultiLivestreamListingModal;